import { LocationStringMap, combineLocationString } from '../../../util/index';
import { Http, RequestMethod, Resource } from '../../models/index';
import { UseCase } from '../UseCase';
import { CreateRequest } from './CreateRequest';
import { GetLink } from './GetLink';
import { ReplaceParams } from './ReplaceParams';

export namespace RequestResource {
    export interface Params<L extends string, T> {
        parent: Resource<L>;
        rel: L;
        method: RequestMethod;
        body?: T;
        search?: LocationStringMap;
        noLinkError?: boolean;
        queryParams?: object;
    }
}

export class RequestResource<L extends string, T, V>
    implements UseCase<RequestResource.Params<L, T>, Promise<V | undefined>>
{
    private getLink = new GetLink<L>();
    private createRequest = new CreateRequest();
    private replaceParams = new ReplaceParams<string>();

    constructor(private http: Http) {}

    execute(params: RequestResource.Params<L, T>): Promise<V | undefined> {
        const { parent, rel, queryParams, body } = params;
        const linkObj = this.getLink.execute({ parent, rel });
        let link;
        if (linkObj) {
            link = linkObj.href;
        }

        if (link) {
            if (queryParams) {
                link = this.replaceParams.execute({ link, queryParams });
            }
            return this.http
                .request<T, V>(
                    this.createRequest.execute({
                        method: params.method,
                        url: link,
                        body: params.body,
                        search: params.search && `${combineLocationString(params.search)}`
                    })
                )
                .then((response) => response.body);
        } else if (params.noLinkError) {
            return Promise.resolve(undefined);
        } else {
            return Promise.reject(new Error(`${rel} link does not exist`));
        }
    }
}
